import { useLoggerStore } from '@/store/logger/logger-store'
import type { LoggerEvent } from '@/types/logger.types'

import type { DisableAdOrder, Order, Topup } from '.'
import { getPurchaseGamAmount } from './purchase'

type PurchaseAnalyticsOrder = Order | DisableAdOrder | Topup | null

function getOrderGamAmount(order: PurchaseAnalyticsOrder) {
    if (!order) {
        return undefined
    }

    return order.type === 'topup' ? order.amount : getPurchaseGamAmount(order)
}

export function useInGamePurchaseAnalytics() {
    const loggerStore = useLoggerStore()

    function logPurchaseEvent(
        eventName: LoggerEvent['eventName'],
        order: PurchaseAnalyticsOrder,
        amount = getOrderGamAmount(order),
    ) {
        return loggerStore.logEvent({
            event: 'custom_event',
            eventName,
            action: order?.type,
            amountInGameCurrency: amount,
            adPlacement: order?.type === 'disable-ad-order' ? order.placement : undefined,
            dimension1: order?.type,
            dimension2: amount?.toString(),
            dimension3: order?.type === 'order' ? order.description : undefined,
        })
    }

    function logNewSubscriptionAfterInGamePurchase(order: Order) {
        return loggerStore.logEvent({
            event: 'custom_event',
            eventName: 'new_subscription_after_in_game_purchase',
            dimension1: order.type,
            dimension2: order.gamAmount.toString(),
        })
    }

    return { logNewSubscriptionAfterInGamePurchase, logPurchaseEvent }
}
